import request from './http'
const baseUrl = '/apass-business'
const apassBaseUrl = '/apass-base'
// 保存工作表字段
export const updateNodeById = (data: any) =>
  request({
    url: baseUrl + '/api/workFlow/node/updateNode',
    method: 'post',
    data
  })
// 节点明细
export const getNodeById = (data: any) =>
  request({
    url: baseUrl + '/api/workFlow/node/getNode',
    method: 'get',
    params: data
  })
// 新增短信模版
export const addSmsTemplate = (data: any) =>
  request({
    url: apassBaseUrl + '/api/smsTemplate/insert',
    method: 'post',
    data
  })
// 新增短信模版
export const updateSmsTemplate = (data: any) =>
  request({
    url: apassBaseUrl + '/api/smsTemplate/update',
    method: 'post',
    data
  })
// 删除短信模版
export const delSmsTemplate = (data: any) =>
  request({
    url: apassBaseUrl + '/api/smsTemplate/delete',
    method: 'post',
    data
  })
// 查询短信模版
export const getSmsTemplateList = (data: any) =>
  request({
    url: apassBaseUrl + '/api/smsTemplate/list',
    method: 'post',
    data
  })
// 查询简单工作表配置
export const getSimpleConfigList = (data: any) =>
  request({
    url: baseUrl + '/api/worksheet/getSimpleConfig/' + data.worksheetId,
    method: 'get',
    data
  })
// 保存工作表字段
export const saveSheetConfig = (data: any) =>
  request({
    url: baseUrl + '/api/field/save',
    method: 'post',
    data
  })
// 获取工作表字段  
export const getSheetConfig = (data: any) =>
  request({
    url: baseUrl + '/api/worksheet/getConfig',
    method: 'post',
    data
  })
// 获取所有工作表 
export const getCompanySheet = (applicationId) =>
  request({
    url: baseUrl + '/api/company/worksheet/' + applicationId,
    method: 'get',
  })
// 获取应用下的工作表  
export const getApplicatioSheet = (applicationId) =>
  request({
    url: baseUrl + '/api/application/worksheet/' + applicationId,
    method: 'get',
  })  
// 获取所选视图的展示字段  
export const getViewShowFields = (worksheetId) =>
  request({
    url: baseUrl + '/api/view/getViewShowFields/' + worksheetId,
    method: 'get',
  })
// 创建工作流
export const createWorkFlowConfig = (data) =>
  request({
    url: baseUrl + '/api/workFlow/config/init',
    method: 'post',
    data
  })
// 修改工作流
export const updateWorkFlowConfig = (data) =>
  request({
    url: baseUrl + '/api/workFlow/config/update',
    method: 'post',
    data
  })  
// 获取工作流列表  
export const getWorkFlowList = (data) =>
  request({
    url: baseUrl + '/api/workFlow/config/list',
    method: 'GET',
    params: data
  })  
// 添加节点  
export const addNode = (data) =>
  request({
    url: baseUrl + '/api/workFlow/node/addNode',
    method: 'post',
    data
  })
// 删除节点  
export const deleteNode = (data) =>
  request({
    url: baseUrl + '/api/workFlow/node/deleteNode',
    method: 'post',
    data
  })
// 工作流明细
export const getFlowById = (flowId) =>
  request({
    url: baseUrl + `/api/workFlow/config/${flowId}`,
    method: 'get',
  })    
